
import React from 'react';
// import $ from 'jquery';
import OwlCarousel from "react-owl-carousel-rtl";
import '../../../node_modules/owl.carousel/dist/assets/owl.carousel.css'
import '../../../node_modules/owl.carousel/dist/assets/owl.theme.default.css';


const CilentSec = ({ cilentsList }) => {
    // console.log(cilentsList);

    const options = {
        loop: true,
        // rtl:true,
        margin: 25,
        autoplay: true,
        dots: false,
        autoplayTimeout: 8500,
        smartSpeed: 450,
        nav: true,
        responsive: {
            0: {
                items: 2
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            1200: {
                items: 5
            }
        }
    };


    return (
        <section className="cilents-sec">
            <div className="block-title">
                <h6 className="title">مشتریان</h6>
            </div>

            <OwlCarousel className='owl-carousel owl-theme'  {...options} rtlClass="owl-rtl" rtl={true} >
                {cilentsList?.map((item) =>
                    <div className="item" key={item.id}>
                        <div className="cilents-slider-item d-block">
                            <img src={`https://amirsabit.4api.ir/uploads/Cilents/${item.imagecilents}`} title={item.name} alt={item.name} className="img-fluid" />
                        </div>
                    </div>
                )}

            </OwlCarousel>

        </section>
    )
}
export default CilentSec;